module.exports = __webpack_public_path__ + "static/images/warning-yellow.3obDh0v.svg";